import React from 'react'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// hooks
import { useRelatedFields } from 'hooks/risks/useRelatedFields'
// components
import Fields from './Fields'

const RelatedFields: React.FC = () => {
  const { riskView } = React.useContext(RiskRegisterContext)

  const { relatedForms } = useRelatedFields()

  if (!relatedForms.length) {
    return null
  }

  const activeFields = riskView?.settings?.fields?.filter((field) => field.riskTemplateId && (field.active ?? true)) || []

  // Archived fields can stay in the view settings, but the rows (RiskTemplateAPI) drop them (field links excepted)
  const isFieldActive = (field) =>
    (field.fieldLinkId || field.active) &&
    activeFields.some(
      ({ fieldId, fieldLinkId, parentFieldId }) =>
        fieldId === field.id && (fieldLinkId ? parentFieldId === field.parentFieldId : !fieldLinkId)
    )

  return (
    <>
      {relatedForms.map((item) => (
        <Fields key={item.id} fields={item.fields.filter(isFieldActive)} />
      ))}
    </>
  )
}

export default RelatedFields
